import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  text-align: center;
`

export const MessageWrapper = styled.div`
  ${TypeStyle.css.headlineExtraSmall}
  color: ${o => o.theme.color.deprecated.obsidian};
  margin-bottom: 20px;
`
